'use client';

import type { TextProps } from '@/core/types';

import React from 'react';

import { Box, Button, Container, Typography } from '@/components/ui';

import { RouterLink } from '@/routes/components';

export default function TextBlock({
  title,
  description,
  features,
  buttons,
  className = '',
}: TextProps) {
  return (
    <section className={`relative py-[36px] md:py-[114px] ${className}`}>
      <Container>
        <Box className="flex items-center justify-center flex-col max-w-4xl mx-auto">
          {title && (
            <Typography
              variant="h2"
              className="text-center uppercase md:text-[42px] font-bold mb-2 text-primary-dark"
            >
              {title}
            </Typography>
          )}

          {description && (
            <Box
              className="text-center mb-2 font-medium md:text-2xl [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-4"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}

          {features && features.length > 0 && (
            <Box component="ul" className="flex pl-6 mt-2 gap-2">
              {features.map((item, idx) => (
                <li key={idx} className="mb-2 px-4 border-l-1 border-gray-300 last:border-r-1">
                  {item}
                </li>
              ))}
            </Box>
          )}

          {buttons && buttons.length > 0 && (
            <Box className="flex flex-wrap gap-3 mt-6">
              {buttons.map((button, index) => (
                <Button
                  key={index}
                  href={button.link}
                  component={RouterLink}
                  variant={button.variant}
                  target={button.target}
                  className={button.className}
                >
                  {button.text}
                </Button>
              ))}
            </Box>
          )}
        </Box>
      </Container>
    </section>
  );
}
